import * as React from "react";
const SvgSubCategories = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    fill="none"
    {...props}
  >
    <circle cx={1.5} cy={5} r={1.5} fill="#082B60" />
    <path
      stroke="#082B60"
      strokeLinecap="round"
      strokeWidth={3}
      d="M6.5 5h20"
    />
    <circle cx={1.5} cy={14} r={1.5} fill="#082B60" />
    <path
      stroke="#082B60"
      strokeLinecap="round"
      strokeWidth={3}
      d="M6.5 14h20"
    />
    <circle cx={1.5} cy={23} r={1.5} fill="#082B60" />
    <path
      stroke="#082B60"
      strokeLinecap="round"
      strokeWidth={3}
      d="M6.5 23h20"
    />
  </svg>
);
export default SvgSubCategories;
